import React from 'react';
import { Spinner } from '@chat/components';
import IM from './index';
import Default from '../Default';

interface IProps {
    code: number;
    isLoading: boolean;
}
function Container({ code, isLoading }: IProps): JSX.Element {
    /** 页面渲染控制 */
    const PageRender = () => {
        const swiper = {
            0: <IM />,
            default: <Default code={code} />
        };
        if (isLoading) {
            return <Spinner type="global" />;
        }
        return swiper[code] || swiper.default;
    };
    return <PageRender />;
}

export default Container;
